import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { track } from "@/lib/track";
import { Spinner } from "@/components/ui-kit";

// One-click demo: logs into the seeded demo parent server-side (no visible creds).
export default function DemoLogin() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    track("demo_started", { source: "demo_route" });
    (async () => {
      try {
        const { data } = await api.post("/auth/demo-login");
        localStorage.setItem("ns_token", data.access_token);
        setUser(data.user);
        nav("/home", { replace: true });
      } catch {
        toast.error("Demo is unavailable right now. Please try again.");
        nav("/", { replace: true });
      }
    })();
  }, []);
  return <div className="min-h-screen grid place-items-center bg-[var(--ns-bg)]" data-testid="demo-login"><Spinner label="Opening the demo" /></div>;
}
